module.exports = __webpack_public_path__ + "img/facilities_02.1d320d53.jpg";